<template>
  <a-modal
    v-model:visible="showmodal"
    :title="$t('js.chi_tiet_don_hang')"
    :destroyOnClose="true"
    :closable="true"
    centered
    width="1200px"
    :cancel-text="$t('js.tro_lai')"
    :bodyStyle="{
      padding: '0px',
      overflowY: 'auto',
      overflowX: 'hidden',
    }"
   
  >
    <template #footer>
      <a-button key="back" @click="hideModal"> {{ $t('js.tro_lai') }} </a-button>
    </template>
    <o-order
      :show="showmodal"
      :form="form"
      @showRate="showRate($event)"
      @reorder="reorder($event)"
    />
  </a-modal>
</template>

<script>
// import EventBus from "@/event-bus";
import mixins from "@/mixins";
import ColumnConfig from "@/common/ColumnConfig";
import OrderTracking from "@/pages/OrderCustomer/OrderTracking";
import Order from "@/components/Order/Show";
// import VueQrcode from "@chenfengyuan/vue-qrcode";
import constant from "@/constant";

export default {
  mixins: [mixins],
  components: {
    "o-order": Order,
  },
  props: {
    showmodal: {
      type: Boolean,
      default: false,
    },
    form: {},
    // orderTracking: {
    //   type: Object,
    //   default: {}
    // },
    // orderSelected: Object
  },
  emits: ["saveStatus", "hideModal", "reorder"],
  data() {
    const columns = ColumnConfig.VehicleRequest;
    return {
      visible: false,
      columns,
      size: "small",
      collapse: true,
      modalWidth: 0,
      iconCollapse: "double-left",
      left: "25%",
      orderStatus: constant.orderCustomerStatus,
      okProps: {
        style: {
          backgroundColor: "#11509b",
          borderColor: "#11509b",
          width: "120px",
        },
      },
    };
  },
  methods: {
     hideModal() {
      this.$emit("hideModal");
    },
    reorder($event) {
      this.$emit("reorder", $event);
    },
    renderStep(history) {
      let status = this.orderStatus.find((p) => p.value == history.status);
      if (!status) {
        return;
      }
      return status.text;
    },
    renderOrderCustomerStatus(history) {
      let status = this.orderCustomerStatus.find(
        (p) => p.value == history.status
      );
      if (!status) {
        return;
      }
      return status.text;
    },
  },
  mounted() {
  },
  computed: {
  },

 
};
</script>

<style lang="scss">
.pdt-12 {
  padding-top: 12px;
}

.order-tracking {
  margin-top: 16px;
}

.nav-list {
  margin: 8px 0;
}

.ant-collapse-borderless {
  background-color: white !important;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 16px 0 16px;
}

.item > a {
  font-size: 14px;
  display: inline-block;
  color: #8c8888;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.item > a > i {
  margin-right: 4px;
}

.item:hover > a {
  color: #000;
}

.order-detail-sidebar-header > .title {
  padding: 16px;
  font-size: 14px;
  text-transform: uppercase;
  color: #8c8888;
  border-bottom: 1px solid #d9d9d9;
}

.on-collapse {
  background-color: #e0e0e0;
  cursor: pointer;
  top: 50%;
  height: 48px;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 1;
  border-radius: 4px;
}

.list-order {
  display: flex;
}

.item-order {
  font-weight: 600;
  padding: 3px 5px;
  font-size: 12px;
  background-color: #52bb56;
  border-radius: 4px;
  margin-left: 2px;
  color: #fff;
}

.list-car {
  padding: 16px 0;
}

.order-info {
  margin-bottom: 0;
}



.dialog-class {
  .ant-modal,
  .ant-modal-content {
    height: 100vh;
    width: 100vw;
    margin: 0;
    top: 0;
  }
  .ant-modal-body {
    height: calc(100vh - 110px);
  }
  .ant-modal-header {
    border-bottom: 0;
    .ant-modal-title {
      font-weight: bold !important;
    }
  }
}
</style>
